import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Transition } from 'react-transition-group';

import Archetype from './Archetype';

import { updateResult } from '../../actions';
import { track } from '../../utils/analytics';

import style from './index.module.scss';

class Results extends Component {
  constructor(props) {
    super(props);

    this.state = {
      active: false,
      current: -1
    }

    this.handleArchetypeChange = this.handleArchetypeChange.bind(this);
  }

  handleArchetypeChange(index) {
    const { dispatch } = this.props;
    track('clicked', `Archetype changed to ${index}`);
    dispatch(updateResult(index));
  }

  render() {
    const { view: { id }, base: { archetypes }, quiz: { results: { current } } } = this.props;
    const show = id === 'results';

    return (
      <Transition
        timeout={0}
        in={show}
        onEnter={() => this.setState(() => ({ active: true }))}
        onExit={() => this.setState(() => ({ active: false }))}
      >
        <div className={`${style.results} view ${show ? style.active : ''}`}>
          {archetypes.map((archetype, index) => <Archetype show={show && index === current} result={current} archetypes={archetypes} archetype={archetypes[index]} key={`archetype-${index}`} onArchetypeChange={this.handleArchetypeChange} />)}
        </div>
      </Transition>
    )
  }
}

const mapStateToProps = state => ({
  view: state.view,
  quiz: state.quiz,
  base: state.base,
  themes: state.themes
});

export default connect(mapStateToProps)(Results);
